import {permissionToBool} from '../../utils';

export function getDeliveryPermissions(deliveryPermission?: string | null) {
  return {
    canView: permissionToBool(deliveryPermission?.charAt(0)),
    canEdit: permissionToBool(deliveryPermission?.charAt(1)),
    canAdd: permissionToBool(deliveryPermission?.charAt(3)),
    canDelete: permissionToBool(deliveryPermission?.charAt(4)),
  };
}

export function canOpenDeliveryForm(deliveryPermission?: string | null) {
  const {canAdd, canEdit} = getDeliveryPermissions(deliveryPermission);

  return canAdd || canEdit;
}
